import axios from "axios";
import { useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Context } from "../../context/context";

const PUBLIC_ROUTES = ["/signin", "/signup", "/forgotpassword"];

const AxiosInterceptor = (props) => {
  // state
  const { state, dispatch } = useContext(Context);
  const { user } = state;

  // router
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user && !PUBLIC_ROUTES.includes(location.pathname)) navigate("/signin");
    else if (user) window.sessionStorage.setItem("user", JSON.stringify(user));
  }, [user, navigate, location.pathname]);

  useEffect(() => {
    axios.interceptors.response.use(
      function (response) {
        // status 2XX code
        return response;
      },
      function (error) {
        // status code outside 2XX
        let res = error.response;
        if (res.status === 401 && res.config && !res.config.__isRetryRequest) {
          return new Promise((resolve, reject) => {
            axios
              .get("/app-api/user/logout")
              .then((data) => {
                console.log("401 error > logout");
                dispatch({ type: "LOGOUT" });
                window.sessionStorage.removeItem("user");
                navigate("/signin");
              })
              .catch((err) => {
                console.log("AXIOS INTERCEPTORS ERROR", err);
                reject(err);
              });
          });
        }
        return Promise.reject(error);
      },
    );
  });

  return <></>;
};

export default AxiosInterceptor;
